import { cn } from '~/lib/utils';

interface LogoProps {
  className?: string;
}
export const EmailChecked = ({ className }: LogoProps) => {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(!!className && className)}
    >
      <circle cx="38" cy="38" r="38" fill="#F0F0F0" />
      <path
        d="M29 30.5C28.1703 30.5 27.5 31.1703 27.5 32V33.8703L36.6688 40.5922C37.4609 41.1734 38.5391 41.1734 39.3312 40.5922L48.5 33.8703V32C48.5 31.1703 47.8297 30.5 47 30.5H29ZM27.5 35.7313V44C27.5 44.8297 28.1703 45.5 29 45.5H47C47.8297 45.5 48.5 44.8297 48.5 44V35.7313L40.2172 41.8016C38.8953 42.7672 37.1 42.7672 35.7828 41.8016L27.5 35.7313ZM26 32C26 30.3453 27.3453 29 29 29H47C48.6547 29 50 30.3453 50 32V44C50 45.6547 48.6547 47 47 47H29C27.3453 47 26 45.6547 26 44V32Z"
        fill="#111A07"
      />
      <circle cx="66" cy="10" r="10" fill="#111A07" />
      <g clip-path="url(#clip0_88_216)">
        <path
          d="M71.507 6.2085C71.6627 6.35986 71.6627 6.60889 71.507 6.76025L64.6766 13.4009C64.521 13.5522 64.2648 13.5522 64.1091 13.4009L60.4931 9.88525C60.3374 9.73389 60.3374 9.48486 60.4931 9.3335C60.6487 9.18213 60.9049 9.18213 61.0606 9.3335L64.3929 12.5732L70.9395 6.2085C71.0952 6.05713 71.3513 6.05713 71.507 6.2085Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_88_216">
          <rect width="11.25" height="12.5" fill="white" transform="translate(60.375 3.75)" />
        </clipPath>
      </defs>
    </svg>
  );
};
